export const phoneRegExp = /^(\+0?1\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/;
export const phoneNoMaskRegExp = /^(\d{10})?$/;

export const phoneNoMaskRegExpModified = /^([2-9][0-9]{2}[0-9][0-9]{6})?$/;


export const zipCodeRegExp = /^[0-9]{5}(?:-[0-9]{4})?$/;
export const zipCodeNoMaskRegExp = /^([0-9]{5}(?:[0-9]{4})?)?$/;
export const ssnRegExp = /^((?!666|000)[0-8][0-9_]{2}-(?!00)[0-9_]{2}-(?!0000)[0-9_]{4})*$/;
export const ssnNoMaskRegExp = /^(\d{9})?$/;
